import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

/** Single wrapper: nested layout/text styles use plain elements + className inside. */
export const RideIncidentsTabWrapStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-incidents-tab",
})`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 22px 12px;
  min-height: 200px;

  .ric-add-row {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }

  .ric-filter-plaque {
    background-color: ${greyMui._100};
    border-radius: 8px;
    padding: 10px 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    flex-wrap: nowrap;
  }

  .ric-filter-plaque__form.MuiFormControl-root {
    margin: 0;
    flex: 1 1 auto;
    min-width: 0;
    width: auto;
    max-width: 100%;
  }

  .ric-filter-plaque__radio-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 4px;
  }

  .ric-filter-plaque__refresh {
    flex-shrink: 0;
    margin-left: auto;
  }

  .ric-loading {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: ${greyMui._600};
  }

  .ric-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .ric-list-item {
    border: 1px solid ${greyMui._300};
    border-radius: 6px;
    padding: 10px 12px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .ric-row-head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-width: 0;
  }

  .ric-row-head__left {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    min-width: 0;
    flex: 1 1 auto;
    max-width: 100%;
  }

  .ric-row-head__right {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 6px 12px;
    min-width: 0;
    flex: 0 1 auto;
    text-align: right;
  }

  .ric-row-head__by {
    margin: 0;
    font-size: 12px;
    line-height: 18px;
    color: ${greyMui._600};
    max-width: 100%;
  }

  .ric-status-chip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 2px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0.02em;
    color: #ffffff;
  }

  .ric-status-chip--new {
    background-color: #f57c00;
  }

  .ric-status-chip--closed {
    background-color: #1b5e20;
  }

  .ric-type-block {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    min-width: 0;
  }

  .ric-row-title {
    margin: 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ric-row-head__when {
    margin: 0;
    flex-shrink: 0;
    font-size: 13px;
    line-height: 20px;
    color: ${greyMui._600};
    white-space: nowrap;
  }

  .ric-muted {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: ${greyMui._600};
  }

  .ric-detail--closed-meta + .ric-detail--remarks {
    margin-top: 4px;
  }

  .ric-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 4px;
  }
`;

/** Type color swatch (hex from API); `$color` is a transient styled-components prop. */
export const RicTypeColorDotStyled = styled.span.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-incident-type-color-dot",
})<{ $color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1px solid ${greyMui._300};
  background-color: ${p => p.$color};
`;
